import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.hard-token-management.hotp-totp-add', {
        url: '/add-hard-tokens',
        // component: 'addFidoTokens'
        views: {
            '@company': 'addHotpTotpTokens'
        }
    })
}





// WEBPACK FOOTER //
// ./src/portal/states/company/hard-token-management/hard-token-add/hotp-totp-add/hotp-totp-add.state.js